export default "__VITE_ASSET__DV0KW60y__"